import { Download, ExternalLink } from 'lucide-react';
import Button from '../../components/ui/Button.jsx';

const MANUAL_URL = '/documents/manual-usuario-dashboard-admin.pdf';

export default function ManualUsuarioAdminPage() {
  return (
    <div className="mx-auto max-w-6xl space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-accent-blue md:text-4xl">
            Manual de usuario
          </h1>
          <p className="mt-2 max-w-2xl text-slate-600">
            Guía de funcionamiento del panel administrativo de Coonaltragas.
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={() => window.open(MANUAL_URL, '_blank', 'noopener,noreferrer')}
          >
            <ExternalLink className="h-4 w-4" />
            Abrir en otra pestaña
          </Button>
          <a
            href={MANUAL_URL}
            download="manual-usuario-dashboard-coonaltragas.pdf"
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-brand-green px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-green/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green"
          >
            <Download className="h-4 w-4" />
            Descargar
          </a>
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <iframe
          src={MANUAL_URL}
          title="Manual de usuario del panel administrativo"
          className="h-[75vh] min-h-[520px] w-full"
        />
      </div>
    </div>
  );
}
